import Vue from 'vue'
import VueRouter from 'vue-router'
import {checkLogin} from '@/plugins/utils'
import {getCookie} from "@/utils";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "index" */ '@/views/index/index')
	},
	{
		path: '/register',
		name: 'register',
		component: () => import(/* webpackChunkName: "register" */ '@/views/login/register')
	},
	{
		path: '/index/create',
		component: () => import(/* webpackChunkName: "index" */ '@/views/index/create')
	},
	{
		path: '/index/group',
		component: () => import(/* webpackChunkName: "index" */ '@/views/index/group')
	},
	{
		path: '/index/trafficRecharge',
		component: () => import(/* webpackChunkName: "index" */ '@/views/index/trafficRecharge')
	},
	{
		path: '/index/rechargeList',
		component: () => import(/* webpackChunkName: "index" */ '@/views/index/rechargeList')
	},
	{
		path: '/course/index',
		component: () => import(/* webpackChunkName: "course" */ '@/views/course/index')
	},
	{
		path: '/course/details',
		component: () => import(/* webpackChunkName: "course" */ '@/views/course/details')
	},
	{
		path: '/contact/index',
		component: () => import(/* webpackChunkName: "contact" */ '@/views/contact/index')
	},
	{
		path: '/contact/screen',
		component: () => import(/* webpackChunkName: "contact" */ '@/views/contact/screen')
	},
	{
		path: '/contact/detail',
		component: () => import(/* webpackChunkName: "contact" */ '@/views/contact/detail')
	},
	{
		path: '/contact/course',
		component: () => import(/* webpackChunkName: "contact" */ '@/views/contact/course')
	},
	{
		path: '/my',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/index')
	},
	{
		path: '/my/indexModel',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/indexModel')
	},
	{
		path: '/my/group',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/group')
	},
	{
		path: '/my/recharge',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/recharge')
	},
    {
        path: '/my/addgroupadmin',
        component: () => import(/* webpackChunkName: "my" */ '@/views/my/addGroupAdmin')
    },
	{
		path: '/my/contact',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/contact')
	},
	{
		path: '/my/feedBack',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/feedBack')
	},
	{
		path: '/my/coupon',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/coupon')
	},
	{
		path: '/tool/index',
		component: () => import(/* webpackChunkName: "tool" */ '@/views/tool/index')
	},
	{
		path: '/doctor/index',
		component: () => import(/* webpackChunkName: "tool" */ '@/views/doctor/index')
	},
	// {
	// 	path: '/contactStatistic/index',
	// 	component: () => import(/* webpackChunkName: "contact" */ '@/views/contactStatistic/index')
	// },
	// {
	// 	path: '/channelCode/index',
	// 	component: () => import(/* webpackChunkName: "channelCode" */ '@/views/channelCode/index')
	// },
	{
		path: '/channelCode/create',
		component: () => import(/* webpackChunkName: "channelCode" */ '@/views/channelCode/create')
	},
	{
		path: '/channelCode/detail',
		component: () => import(/* webpackChunkName: "channelCode" */ '@/views/channelCode/detail')
	},
	// {
	// 	path: '/contactWelcome/index',
	// 	component: () => import(/* webpackChunkName: "contactWelcome" */ '@/views/contactWelcome/index')
	// },
	{
		path: '/contactWelcome/create',
		component: () => import(/* webpackChunkName: "contactWelcome" */ '@/views/contactWelcome/create')
	},
	{
		path: '/workMoment/index',
		component: () => import(/* webpackChunkName: "workMoment" */ '@/views/workMoment/index')
	},
	{
		path: '/workMoment/create',
		component: () => import(/* webpackChunkName: "workMoment" */ '@/views/workMoment/create')
	},
	{
		path: '/workMoment/info',
		component: () => import(/* webpackChunkName: "workMoment" */ '@/views/workMoment/info')
	},
	{
		path: '/medium/index',
		component: () => import(/* webpackChunkName: "medium" */ '@/views/medium/index')
	},
	{
		path: '/medium/detail',
		component: () => import(/* webpackChunkName: "medium" */ '@/views/medium/detail')
	},
	{
		path: '/medium/create',
		component: () => import(/* webpackChunkName: "medium" */ '@/views/medium/create')
	},
	{
		path: '/roomTemplatePull/index',
		component: () => import(/* webpackChunkName: "roomTemplatePull" */ '@/views/roomTemplatePull/index')
	},
	{
		path: '/roomTemplatePull/create',
		component: () => import(/* webpackChunkName: "roomTemplatePull" */ '@/views/roomTemplatePull/create')
	},
	{
		path: '/contactDeleteRemind/index',
		component: () => import(/* webpackChunkName: "contactDeleteRemind" */ '@/views/contactDeleteRemind/index')
	},
	{
		path: '/contactLost/index',
		component: () => import(/* webpackChunkName: "contactLost" */ '@/views/contactLost/index')
	},
	{
		path: '/sensitiveWordMonitor/index',
		component: () => import(/* webpackChunkName: "sensitiveWordMonitor" */ '@/views/sensitiveWordMonitor/index')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import(/* webpackChunkName: "login" */ '@/views/login')
	},
	{
		path: '/auth',
		name: 'auth',
		component: () => import(/* webpackChunkName: "auth" */ '@/views/auth')
	},
	{
		path: '/contactMessageBatchSend/index',
		component: () => import(/* webpackChunkName: "contactMessageBatchSend" */ '@/views/contactMessageBatchSend/index')
	},
	{
		path: '/contactMessageBatchSend/create',
		component: () => import(/* webpackChunkName: "contactMessageBatchSend" */ '@/views/contactMessageBatchSend/create')
	},
	{
		path: '/contactMessageBatchSend/details',
		component: () => import(/* webpackChunkName: "contactMessageBatchSend" */ '@/views/contactMessageBatchSend/details')
	},
	{
		path: '/roomMessageBatchSend/index',
		component: () => import(/* webpackChunkName: "roomMessageBatchSend" */ '@/views/roomMessageBatchSend/index')
	},
	{
		path: '/roomMessageBatchSend/details',
		component: () => import(/* webpackChunkName: "roomMessageBatchSend" */ '@/views/roomMessageBatchSend/details')
	},
	{
		path: '/roomMessageBatchSend/create',
		component: () => import(/* webpackChunkName: "roomMessageBatchSend" */ '@/views/roomMessageBatchSend/create')
	},
	{
		path: '/live/index',
		component: () => import(/* webpackChunkName: "live" */ '@/views/live/index')
	},
	{
		path: '/live/watchData',
		component: () => import(/* webpackChunkName: "live" */ '@/views/live/watchData')
	},
	{
		path: '/live/watchDataLive',
		component: () => import(/* webpackChunkName: "live" */ '@/views/live/watchDataLive')
	},
	{
		path: '/my/auditOrder',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/auditOrder')
	},
	{
		path: '/my/orderDetail',
		component: () => import(/* webpackChunkName: "my" */ '@/views/my/orderDetail')
	},
    {
        path: '/robot/login',
        name: 'robotlogin',
        component: () => import(/* webpackChunkName: "live" */ '@/views/robot/login.vue')
    },
    { path: '/robot/labels',
        component: () => import(/* webpackChunkName: "live" */ '@/views/robot/labels.vue')
    },
    { path: '/robot/users',
        component: () => import(/* webpackChunkName: "live" */ '@/views/robot/users.vue')
    },
    { path: '/robot/sender',
        component: () => import(/* webpackChunkName: "live" */ '@/views/robot/sender.vue')
    },
    { path: '/robot/send_log',
        component: () => import(/* webpackChunkName: "live" */ '@/views/robot/send_log.vue')
    },
	{
		path:"/double/list",
		name: 'doubleList',
		component: () => import(/* webpackChunkName: "double" */ '@/views/double/list.vue')
	},
	{
		path: '/double/login',
		name: 'doubleLogin',
		component: () => import(/* webpackChunkName: "double" */ '@/views/double/login.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach(async (to, from, next) => {
	const token = getCookie('personbench_token');
	const whiteList = ['login','doubleList','doubleLogin','register'];
    // next(); //TODO:test

	if(token){
		//已经登录则跳转首页
		if (whiteList.includes(to.name)) {
			next({name: 'home'});
		}else{
			next();
		}
	}else{
		// token不存在，全部重定向到登录页，如果本身访问的就是登录页，则直接跳转
		if (whiteList.includes(to.name)) {
			next();
		} else {
			next({name: 'login'});
		}
	}
})

export default router
